<div class="file has-name is-boxed">
    <label class="file-label">
      <input class="file-input" type="file" (change)="uploadFile($event)">
      @if (!apoFile) {
          <span class="file-cta">
            <span class="file-icon">
              <fa-icon [icon]="faFileSpreadsheet"></fa-icon>
            </span>
            <span class="file-name is-align-items-center">
              Toca para subir un archivo
            </span>
          </span>
      }
      @if (apoFile) {
          <div class="file-selected-container">
            <div class="file-selected-content">
              <fa-icon [icon]="faFileExcel" class="file-selected-icon"></fa-icon>
              <div class="file-selected-info">
                <p class="file-selected-name">{{ apoFile?.name }}</p>
                <p class="file-selected-size">{{ (apoFile.size / 1024).toFixed(2) }} KB</p>
              </div>
              <fa-icon [icon]="faCheckCircle" class="file-selected-check"></fa-icon>
            </div>
            <button type="button" class="file-remove-btn" (click)="removeFile($event)">
              <fa-icon [icon]="faX"></fa-icon>
              <span>Cambiar archivo</span>
            </button>
          </div>
      }
    </label>
  </div>